namespace Portico.Models.Enterprise {
	import psge = apigateway.enums;
	import psgm = apigateway.models;

    export interface IPatient {
		id: string;
        ssn: string;
        firstName: string;
        middleName: string;
        lastName: string;
        suffix: string;
        nickName: string;
        gender: string;
        dateOfBirth: Date;
        primaryLanguageId: number;
		isUsResident: boolean;
		householdSize: number;
		addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        phoneNumbers: PhoneNumber[];

		mapToEnterpriseCoordinatorPatientUpsearchModel(): psgm.EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel;
		mapToEnterpriseCoordinatorPatientUpsearchModelWithFlags(canUpdate: boolean, canInsert: boolean, skipSearch: boolean): psgm.UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel;
	}

    export class Patient implements IPatient {
        id: string;
        ssn: string;
        firstName: string;
        middleName: string;
        lastName: string;
        suffix: string;
        nickName: string;
        gender: string;
        dateOfBirth: Date;
        primaryLanguageId: number;
		isUsResident: boolean;
		householdSize: number;
        addresses: Address[];
		contacts: Contact[];
        emailAddresses: EmailAddress[];
        phoneNumbers: PhoneNumber[];

        constructor(obj?: IPatient | any) {
            this.id = null;
            this.ssn = '';
            this.firstName = '';
            this.middleName = '';
            this.lastName = '';
            this.suffix = '';
            this.nickName = '';
            this.gender = null;
            this.dateOfBirth = null;
			this.primaryLanguageId = null;
			this.isUsResident = true;
			this.householdSize = 0;
			this.addresses = [];
			this.contacts = [];
            this.emailAddresses = [];
            this.phoneNumbers = [];

            if (obj) {
				this.id = obj.id || obj.patientId || null;
				this.ssn = obj.ssn || obj.socialSecurityNumber || '';
				this.firstName = obj.firstName || '';
				this.middleName = obj.middleName || '';
				this.lastName = obj.lastName || '';
				this.suffix = obj.suffix || '';
				this.nickName = obj.nickName || obj.nickname || '';
				this.gender = isNaN(obj.gender) ? obj.gender : Portico.Models.Gateway.Gender[obj.gender];
				this.primaryLanguageId = obj.primaryLanguageId || null;
				this.isUsResident = obj.isUsResident || true;
				this.householdSize = obj.householdSize || 0;

                if (obj.dateOfBirth) {
					this.dateOfBirth = typeof obj.dateOfBirth === 'string' ? moment.utc(obj.dateOfBirth).toDate() : new Date(obj.dateOfBirth.getTime());					
                }

				if (obj.addresses) {
					for (const address of obj.addresses) {
						this.addresses.push(new Address(address));
					}
				}

				if (obj.contacts) {
					for (const contact of obj.contacts) {
						this.contacts.push(new Contact(contact));
					}
				}

                if (obj.emailAddresses) {
                    for (const emailAddress of obj.emailAddresses) {
                        this.emailAddresses.push(new EmailAddress(emailAddress));
                    }
                }

                if (obj.phoneNumbers) {
                    for (const phoneNumber of obj.phoneNumbers) {
                        this.phoneNumbers.push(new PhoneNumber(phoneNumber));
                    }
                }
            }
        }

		mapToEnterpriseCoordinatorPatientUpsearchModel(): psgm.EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel {
			return {
				patientId: this.id,
				firstName: this.firstName,
				middleName: this.middleName ? this.middleName : "",
				lastName: this.lastName,
				suffix: this.suffix ? this.suffix : "",
				nickname: this.nickName ? this.nickName : "",
				dateOfBirth: moment(this.dateOfBirth),
				gender: psge.Gender[this.gender],
				primaryLanguageId: this.primaryLanguageId,
				isUsResident: this.isUsResident,
				householdSize: this.householdSize,
				socialSecurityNumber: this.ssn,
				addresses: this.addresses ? _.map(this.addresses, addr => {
					return addr.mapToEnterpriseCoordinatorAddress();
				}) : [],
				emailAddresses: this.emailAddresses ? _.map(this.emailAddresses, email => {
					return email.mapToEnterpriseCoordinatorEmailAddress();
				}) : [],
				phoneNumbers: this.phoneNumbers ? _.map(this.phoneNumbers, ph => {
					return ph.mapToEnterpriseCoordinatorPhoneUpsearchModel();
				}) : []
			} as psgm.EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel;
		}

		mapToEnterpriseCoordinatorPatientUpsearchModelWithFlags(canUpdate: boolean, canInsert: boolean, skipSearch: boolean): psgm.UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel {
			return {
				canUpdate: canUpdate,
				canInsert: canInsert,
				skipSearch: skipSearch,
				model: this.mapToEnterpriseCoordinatorPatientUpsearchModel()
			};
		}
    }
}